( function () {
   
    'use strict';

    ( function ( $ ) {
        $('.popup-video-overlay-content-two').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            callbacks: {
              open: function() {
                $("body").addClass("overflow");
                $(this.content).find('video')[0].play();
             },
              close: function() {
                $("body").removeClass("overflow");
                jQuery(this.content).find('video')[0].pause();
              }
            }
        });
        $('.video-overlay-two').slick({
          dots:false,
          infinite: true,
          speed: 600,
          slidesToShow: 6,
          slidesToScroll: 1,
          autoplay:false,
          autoplaySpeed: 1500,
          arrows:true,
          variableWidth: true,
          responsive: [
          {
              breakpoint: 1023,
              settings: {
                  slidesToShow:4,
                  slidesToScroll:1,
                  infinite: true,
              }
          },
          {
              breakpoint:767,
              settings: {
                  slidesToShow:1,
                  slidesToScroll:1,
                  centerPadding: '20px',
                  centerMode: true,
              }
          }
          ]
      });
       
        if($('.search-btn').length > 0){
            $('#trending').on('click', function() {
                
                var text = $('#trendingdata').val();
                var types = 'trendings';
                if(text.length > 2){
                    $.ajax({
                        type: "POST",
                        cache: false,
                        url: ssAjax.ajaxurl,
                        data: { nonce: ssAjax.nonce, text:text, types:types,action: 'getserchvid' },
                        dataType: 'html',
                        success: function (responses) {
                             
                            // $(".loaders").fadeOut();
                            // $(".fixtures-tab-detail").addClass('active');
                            
                            $(".video-overlay-two").html("");
                            $(".video-overlay-two").removeClass("slick-initialized slick-slider");
                            $(".video-overlay-two").html(responses);
                            getnewsslider2();
                        }
                    });
                }
                else{
                    $.ajax({
                        type: "POST",
                        cache: false,
                        url: ssAjax.ajaxurl,
                        data: { nonce: ssAjax.nonce, types:types,action: 'getserchvid' },
                        dataType: 'html',
                        success: function (responses) {
                             
                            // $(".loaders").fadeOut();
                            // $(".fixtures-tab-detail").addClass('active');
                            
                            $(".video-overlay-two").html("");
                            $(".video-overlay-two").removeClass("slick-initialized slick-slider");
                            $(".video-overlay-two").html(responses);
                            getnewsslider2();
                        }
                    });
                }
                
            });

            const zeroPad = (num, places) => String(num).padStart(places, '0');
           // var listItems = $(".video-overlay-box");
            $(".video-overlay-box .vidz").each(function(){
                // var product = $(li);
                var $el = $(this);
               
                $el.one('loadedmetadata play', function () {
                    var total =  $el[0].duration; // Total number of seconds with 0 decimal places
                    var minutes = Math.floor(total / 60); // Seconds divided by 60 to get total minutes
                    var seconds = total % 60;
                    var fsec= seconds.toFixed(0);
                    var timer = (zeroPad(minutes, 2))+':'+(zeroPad(fsec, 2));
                    //console.log('loaded, duration is now',minutes,seconds.toFixed(0));
                    
                    $(this).parent().parent().parent().parent().parent().find('.timer').html(timer);
                });

                // var product = $(this).find('.vidz').duration;
                // alert(product);
                
                // and the rest of your code
            });
                
        }
        function getnewsslider2() {
            $('.video-overlay-two').slick({
                dots:false,
                infinite: true,
                speed: 600,
                slidesToShow: 6,
                slidesToScroll: 1,
                autoplay:false,
                autoplaySpeed: 1500,
                arrows:true,
                variableWidth: true,
                responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow:4,
                        slidesToScroll:1,
                        infinite: true,
                    }
                },
                {
                    breakpoint:767,
                    settings: {
                        slidesToShow:1,
                        slidesToScroll:1,
                        centerPadding: '20px',
                        centerMode: true,
                    }
                }
                ]
            });
            $('.popup-video-overlay-content-two').magnificPopup({
                type: 'inline',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
                callbacks: {
                  open: function() {
                    $("body").addClass("overflow");
                    $(this.content).find('video')[0].play();
                 },
                  close: function() {
                    $("body").removeClass("overflow");
                    jQuery(this.content).find('video')[0].pause();
                  }
                }
            });
        }

    } )(jQuery);
} )();

